<div *ngIf="skin != 'china' && skin != 'kitten'" class="cat">
    <div class="cat_body {{skin}}" >
        <div class="cat_tail"></div>
        <div class="cat_right_hand"></div>
        <div class="cat_head">
            <div *ngIf="skin == 'snow'" class="cat_head_cap"></div>
        </div>
        <div class="cat_left_hand"></div>
        <div class="cat_left_lag"></div>
        <div class="cat_right_lag"></div>
        <div class="cat_right_smog"></div>
    </div>
</div>

<div *ngIf="skin == 'heart'"  class="heart">
    <div class="heart1"></div>
    <div class="heart2"></div>
    <div class="heart3"></div>
</div>

<div  *ngIf="skin == 'heart'" class="cat" style="z-index: 2">
    <div class="cat_body second" >
        <div class="cat_tail"></div>
        <div class="cat_right_hand"></div>
        <div class="cat_head">
            <!--<div class="cat_head_cap"></div>-->
        </div>
        <div class="cat_left_hand"></div>
        <div class="cat_left_lag"></div>
        <div class="cat_right_lag"></div>
        <div class="cat_right_smog"></div>
    </div>
</div>

<div *ngIf="skin == 'china'">
    <div class="cat_body {{skin}}" ></div>
</div>


<div *ngIf="skin == 'kitten'">
    <div  class="cat" style="z-index: -1">
        <div class="cat_body heart" style="transform: translate(-20px,-30px)">
            <div class="cat_tail"></div>
            <div class="cat_right_hand"></div>
            <div class="cat_head">
                <!--<div class="cat_head_cap"></div>-->
            </div>
            <div class="cat_left_hand"></div>
            <div class="cat_left_lag"></div>
            <div class="cat_right_lag"></div>
            <div class="cat_right_smog"></div>
        </div>

        <div class="cat_body second" style="transform: translate(20px,-30px)">
            <div class="cat_tail"></div>
            <div class="cat_right_hand"></div>
            <div class="cat_head">
                <!--<div class="cat_head_cap"></div>-->
            </div>
            <div class="cat_left_hand"></div>
            <div class="cat_left_lag"></div>
            <div class="cat_right_lag"></div>
            <div class="cat_right_smog"></div>
        </div>
    </div>

    <div style="transform: translate(0px,50px); z-index: 2">
        <div class="cat_body kitten1">
            <div class="cat_tail"></div>
            <div class="cat_right_hand"></div>
            <div class="cat_left_hand"></div>
            <div class="cat_head"></div>
            <div class="cat_left_lag"></div>
            <div class="cat_right_lag"></div>
            <!--        <div class="cat_right_smog"></div>-->
        </div>
        <div class="cat_body kitten2" style="transform: translate(80px, 5px)">
            <div class="cat_tail"></div>
            <div class="cat_right_hand"></div>
            <div class="cat_left_hand"></div>
            <div class="cat_head"></div>
            <div class="cat_left_lag"></div>
            <div class="cat_right_lag"></div>
            <!--        <div class="cat_right_smog"></div>-->
        </div>

        <div class="cat_body kitten3" style="transform: translate(-80px, 10px) rotate(10grad)">
            <div class="cat_tail"></div>
            <div class="cat_right_hand"></div>
            <div class="cat_left_hand"></div>
            <div class="cat_head"></div>
            <div class="cat_left_lag"></div>
            <div class="cat_right_lag"></div>
            <!--        <div class="cat_right_smog"></div>-->
        </div>
    </div>
</div>

